import { Component, OnInit, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { Subscription, timer } from 'rxjs';

import { EstatusTareaEnum } from 'src/app/utilerias/enums/estatusTareaDiariaEnum';

export class ITareaDiaria {
  id: number;
  nombre: string;
  estatus: EstatusTareaEnum;
  tiempoTotalInvertido: number;

  constructor(id: number, nombre: string, tiempoTotalInvertido: number) {
    this.id = id;
    this.nombre = nombre;
    this.estatus = EstatusTareaEnum.ACTIVO;
    this.tiempoTotalInvertido = tiempoTotalInvertido;
  }

}
@Component({
    selector: 'app-cronometro',
    standalone: true,
    templateUrl: './app-cronometro.component.html',
    styleUrls: ['./app-cronometro.component.css']
})


export class AppCronometroComponent implements OnInit, OnChanges, OnDestroy {

  hora = '00';
  minutos = '00';
  segundos = '00';
  @Input() useValue: ITareaDiaria;
  private subscription?: Subscription;
  private tiempoBase = 0;
  private inicioTick = 0;

  constructor() { }

  ngOnChanges(_: SimpleChanges) {
    this.inicializarCronometro();
  }

  ngOnInit() {
    this.inicializarCronometro();
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  private inicializarCronometro() {
    this.subscription?.unsubscribe();
    this.tiempoBase = this.useValue?.tiempoTotalInvertido ?? 0;
    this.inicioTick = Date.now();
    this.actualizarCronometro(this.tiempoBase);
    this.subscription = timer(0, 1000).subscribe(() => {
      const transcurrido = Date.now() - this.inicioTick;
      this.actualizarCronometro(this.tiempoBase + transcurrido);
    });
  }

  private actualizarCronometro(milisegundos: number) {
    const totalSegundos = Math.max(0, Math.floor((milisegundos ?? 0) / 1000));
    const horas = Math.floor(totalSegundos / 3600);
    const minutos = Math.floor((totalSegundos % 3600) / 60);
    const segundos = totalSegundos % 60;

    this.hora = String(horas).padStart(2, '0');
    this.minutos = String(minutos).padStart(2, '0');
    this.segundos = String(segundos).padStart(2, '0');
  }

}
